module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/sniffspot-app-desktop-ss-555.2249d87adba43bda.png"+" 555w",
        images: [{path: "https://static.sniffspot.com/packs/img/sniffspot-app-desktop-ss-555.2249d87adba43bda.png",width: 555,height: 488}],
        src: "https://static.sniffspot.com/packs/img/sniffspot-app-desktop-ss-555.2249d87adba43bda.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/sniffspot-app-desktop-ss-555.2249d87adba43bda.png"},
        
        width: 555,
        height: 488
      }